'use client'

import { type FC } from 'react'

import {
  AD_BANNER_PDP_DEFAULT,
  AD_BANNER_PDP_DEFAULT_DIMENSIONS,
  AD_BANNER_PDP_RX,
  AD_BANNER_PDP_RX_DIMENSIONS,
  AdServerBanner,
} from '../../../../ad-server'
import { useDeviceDetectorContext } from '../../../../device-detector'
import { useProductPageContext } from '../../../components/productPageContext'
import { PRODUCT_TEMPLATES } from '../../../model/productTemplates'

export const PdpRightAdBanner: FC = () => {
  const { isMobile } = useDeviceDetectorContext()
  const { productTemplate } = useProductPageContext()

  const isRx = productTemplate === PRODUCT_TEMPLATES.RX
  const bannerTags = [isRx ? AD_BANNER_PDP_RX : AD_BANNER_PDP_DEFAULT]

  const size = isMobile ? 'small' : 'large'
  const dimensions = isRx
    ? AD_BANNER_PDP_RX_DIMENSIONS[size]
    : AD_BANNER_PDP_DEFAULT_DIMENSIONS[size]

  return <AdServerBanner bannerTags={bannerTags} dimensions={dimensions} />
}
